module.exports = __webpack_public_path__ + "static/media/sort-amount-down.28a1f7b8.svg";